<template>
  <v-container>

    <!-- List of stamp cards -->
    <v-card outlined rounded="xl" class="mx-auto px-4 mb-3"
      v-for="sc in stampCards" :key="sc.stampCardId" color="bgGray">

      <v-row align="center" class="pt-2">

        <v-col cols="12">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h6 mb-2">
                {{ sc.stampCardName }}
              </v-list-item-title>
              <v-list-item-subtitle :class="{ 'red--text': sc.collectEndTime < nowTs }">
                集點 {{ sc.collectStartTime | toShortDateString }} - {{ sc.collectEndTime | toShortDateString }}
              </v-list-item-subtitle>
              <v-list-item-subtitle :class="{ 'red--text': sc.redeemEndTime < nowTs }">
                兌換 {{ sc.redeemStartTime | toShortDateString }} - {{ sc.redeemEndTime | toShortDateString }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>

        <!-- <v-col cols="4" class="my-2 d-flex justify-center align-center">
          <v-img max-width="72" max-height="72" class="rounded-lg"
            :src="sc.stampImageUrl">
          </v-img>
        </v-col> -->

        <!-- Action buttons -->
        <v-col cols="12" class="pt-0 d-flex">
          <v-btn text class="flex-grow-1" color="primary"
            @click="$router.push('/admin/stores/' + storeId + '/stamp-cards/' + sc.stampCardId + '/info')">
            集點卡資訊
          </v-btn>
          <v-divider vertical></v-divider>
          <v-btn text class="flex-grow-1" color="primary"
            @click="$router.push('/admin/stores/' + storeId + '/stamp-cards/' + sc.stampCardId + '/transactions')">
            交易記錄
          </v-btn> 
        </v-col>

      </v-row>

    </v-card>

    <!-- Footer - Button for applying withdrawal -->
    <v-footer fixed style="background:transparent;">
      <v-btn large block rounded color="secondary"
        @click="goToCreateStampCard(storeId)">
        <v-icon>mdi-plus</v-icon>
        &nbsp;新增集點卡
      </v-btn>
    </v-footer>

  </v-container>
</template>

<script>
import SSRTable from '@/components/SSRTable.vue';

import SSORequest from '@/sso-request';
// import axios from 'axios';
import moment from 'moment';

export default {
  components: {
    SSRTable
  },
  props: {
    storeId: String
  },

  mounted() {
    this.fetchStampCards();
  },

  methods: {

    fetchStampCards() {
      return SSORequest.get(`${process.env.VUE_APP_TY_STAMPS_HOST}/v1/merchants/${this.user.merchantId}`
        + `/stores/${this.storeId}/stamp-cards`)
      .then(response => {
        this.stampCards = response.data.stampCards;
      })
      .catch(err => {
        this.$notify({
          type: 'error', text: '無法取得集點卡列表！'
        });
      });
    },

    goToCreateStampCard(storeId) {
      if (this.stampCards.length < 1)
        return this.$router.push(`/admin/stores/${storeId}/create-stamp-card`);
      
      this.$swal({
        background: '#ffffff',
        color: '#333333',
        html: '<span style="color:#333333">小提醒：當有多張集點卡時，如其集點期間有所重疊，自動發點功能將會於消費者滿足發放條件時同時給點</span>',
        icon: 'info',
        confirmButtonText: '確定',
        showCloseButton: true
      })
      .then(result => {
        // if (!result.isConfirmed) return;
        this.$router.push(`/admin/stores/${storeId}/create-stamp-card`)
      });
    },
  },

  data() {
    return {
      stampCards: [ ]
    };
  },

  computed: {
    nowTs() {
      return moment().unix();
    },
    user() {
      return this.$store.getters.user;
    }
  },

  filters: {
    toShortDateString(ts) {
      return moment.unix(ts).format('YYYY/M/D');
    }
  }
}
</script>

<style scoped>
.theme--light.v-card {
  background-color: rgba(255, 255, 255, 0.1);
}
</style>